import { atom, selector, selectorFamily } from "recoil";

import { SterWebsiteModelPriceCompareCampaign } from "./api";
import { fetchCalculate, fetchMetadata } from "./apiWrappers";
import { Campaign, SubCampaign } from "./Compare";

export const campaignsState = atom<Partial<Campaign>[]>({
  key: "campaigns",
  default: [{ id: 1, subCampaigns: [{ id: 1 } as SubCampaign] }],
});

export const conversionGroupsState = atom<{ value: string; label: string }[]>({
  key: "conversionGroups",
  default: [],
});

export const mediumState = atom<string | undefined>({
  key: "medium",
  default: undefined,
});

export const campaignsForCalculateState = selector({
  key: "campaignsForCalculate",
  get: ({ get }): SterWebsiteModelPriceCompareCampaign[] | undefined => {
    const input = get(campaignsState);

    // Filter campagnes die de verplichte velden gevuld hebben
    const filteredInput = input
      .map((i) => ({
        ...i,
        subCampaigns: i.subCampaigns?.filter(
          (s) => s._package && s.grps >= 10 && s.grps <= 1000
        ),
      }))
      .filter(
        (i) =>
          i.operator &&
          i.targetGroup &&
          i.period &&
          (i.channels?.length ?? 0) > 0 &&
          (i.subCampaigns?.length ?? 0) > 0
      );

    return filteredInput?.map(
      (s) =>
        ({
          ...s,
          period: { from: s.period?.[0].toDate(), to: s.period?.[1].toDate() },
        } as SterWebsiteModelPriceCompareCampaign)
    );
  },
});

type CalculateCampaign = {
  channels: string[];
  operator: string;
  targetGroup: string;
  period: {
    from: Date;
    to: Date;
  };
  subCampaigns: {
    _package: number;
    grps: number;
    budget?: number;
  }[];
  secondaryTargetGroups?: string[];
}[];

export const calculateState = selectorFamily({
  key: "calculateState",
  get:
    ({
      campaigns,
      conversionGroups,
      medium,
    }: {
      campaigns: CalculateCampaign | undefined;
      conversionGroups: string[];
      medium: string;
    }) =>
    () => {
      if (!campaigns || campaigns.length === 0) {
        return Promise.resolve(undefined);
      }

      return fetchCalculate({
        medium,
        request: { campaigns, conversionGroups },
      });
    },
});

export const metadataState = selectorFamily({
  key: "metadata",
  get: (medium: string) => () => fetchMetadata(medium),
});

export const targetGroupVisibleState = atom<{ [key: string]: boolean }>({
  key: "targetGroupVisibleState",
  default: {},
});

export const targetGroupVisibleSelector = selectorFamily({
  key: "FormField",
  get:
    (targetGroupName: string) =>
    ({ get }) =>
      get(targetGroupVisibleState)[targetGroupName] ?? true,
  set:
    (targetGroupName: string) =>
    ({ set }, newValue) =>
      set(targetGroupVisibleState, (prevState) => ({
        ...prevState,
        [targetGroupName]: newValue as boolean,
      })),
});
